export default __webpack_public_path__ + "static/media/2507231.7dd9a82d.png";